import { BIG_ZERO } from '@pancakeswap/utils/bigNumber'
import BigNumber from 'bignumber.js'
import { DACKIE} from '@pancakeswap/tokens'
import { fetchTokenUSDValue } from '@pancakeswap/utils/fetchTokenUSDValue'
import { useDackiePrice } from '@pancakeswap/utils/useDackiePrice'

// for migration to bignumber.js to avoid breaking changes
// TODO Cake Price
export const useCakePriceAsBN = (chainId: string | number) => {
  // const { data } = useContractRead({
  //   abi: chainlinkOracleABI,
  //   address: contracts.chainlinkOracleCAKE[ChainId.BSC],
  //   functionName: 'latestAnswer',
  //   chainId: ChainId.BSC,
  //   watch: true,
  //   select: (d) => new BigNumber(formatUnits(d, 8)),
  // })

  // return data ?? BIG_ZERO
  const data = useDackiePrice(chainId)?.data || 0
  const dackiePrice = new BigNumber(data.toString())

  return dackiePrice ?? BIG_ZERO
}

// TODO Cake Price
export const getCakePriceFromOracle = async (chainId: string | number) => {
  // const data = await publicClient({ chainId: ChainId.BSC }).readContract({
  //   abi: chainlinkOracleABI,
  //   address: contracts.chainlinkOracleCAKE[ChainId.BSC],
  //   functionName: 'latestAnswer',
  // })

  // return formatUnits(data, 8)
  const data = fetchTokenUSDValue(chainId, DACKIE[chainId].address)
  return data.toString()
}
